import React, { useContext, useState } from "react";
import _ from "lodash";
import { Modal, Button, Upload, Tabs, notification, Alert } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import { GlobalContext } from "./GlobalContext";

const Uploader = ({ uploaderVisible, setUploaderVisible }) => {
    const [loading, setLoading] = useState(false);
    const [fileList, setFileList] = React.useState([]);
    const {
        profile_p1,
        profile_p2,
        record_enso_p1,
        record_enso_p2,
        record_ai_battle,
        mods,
        setAllUserData,
    } = useContext(GlobalContext);

    const userData = {
        profile_p1,
        profile_p2,
        record_enso_p1,
        record_enso_p2,
        record_ai_battle,
        mods,
    };

    const filenames = [
        "profile_p1.json",
        "profile_p2.json",
        "record_enso_p1.json",
        "record_enso_p2.json",
        "record_ai_battle.json",
        "mods.json",
    ];

    const directoryUploadProps = {
        name: "file",
        listType: "picture",
        multiple: true,
        directory: true,
        accept: ".json",
        fileList: fileList,
        customRequest: (request) => {},
        onChange(info) {
            if (
                filenames.includes(info.file.name) &&
                info.file.status === "uploading"
            ) {
                info.file.status = "done";
                let newFileList = fileList;

                // Overwrite file if it already exists
                const index = _.findIndex(newFileList, (file) => {
                    return file.name === info.file.name;
                });

                if (index !== -1) {
                    newFileList[index] = info.file;
                } else {
                    newFileList.push(info.file);
                }

                // Sort file list
                newFileList = _.sortBy(newFileList, (file) => {
                    return file.name;
                });

                setFileList(newFileList);
            } else if (info.file.status === "removed") {
                const index = _.findIndex(fileList, (file) => {
                    return file.uid === info.file.uid;
                });

                if (index !== -1) {
                    fileList.splice(index, 1);
                    setFileList(fileList);
                }
            } else {
                notification.error({
                    message: "Error",
                    description: `File not allowed: ${info.file.name}`,
                });
            }
        },
    };

    // Read file with promise
    const readFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                // Set userData
                const data = JSON.parse(e.target.result);
                const name = file.name.split(".")[0];

                userData[name] = data;

                resolve({
                    name: file.name.replace(".json", ""),
                    content: JSON.parse(e.target.result),
                });
            };
            reader.onerror = (e) => {
                reject(e);
            };
            reader.readAsText(file.originFileObj);
        });
    };

    const handleOk = () => {
        setLoading(true);
        // Read files and update userData
        if (fileList.length > 0) {
            Promise.all(
                fileList.map((file) => {
                    return readFile(file);
                })
            ).then((files) => {
                // Update global state
                setAllUserData(userData);

                setLoading(false);

                // Close modal
                setUploaderVisible(false);

                notification.success({
                    message: "Success",
                    description: "Files were loaded successfully.",
                });
            });
        } else {
            setLoading(false);

            notification.error({
                message: "Error",
                description:
                    "No files were selected. Please select your UserData folder.",
            });
        }
    };

    const handleCancel = () => {
        setUploaderVisible(false);
    };

    return (
        <>
            <Modal
                visible={uploaderVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                destroyOnClose={true}
                maskClosable={false}
                okText={loading ? "Loading..." : "Load Data"}
                okButtonProps={{ loading: loading }}
            >
                <Tabs defaultActiveKey="folder">
                    <Tabs.TabPane tab="UserData Folder" key="folder">
                        <Alert
                            message="All data is processed client-side in your browser. No files are retained or uploaded anywhere."
                            type="info"
                            style={{
                                marginBottom: `15px`,
                            }}
                        />
                        <Upload {...directoryUploadProps}>
                            <Button icon={<UploadOutlined />}>
                                Select your UserData directory...
                            </Button>
                        </Upload>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Individual JSON Files" key="files">
                        Coming soon.
                    </Tabs.TabPane>
                </Tabs>
            </Modal>
        </>
    );
};

export default Uploader;
